//Utilities
import AppDispatcher from '../core/AppDispatcher.jsx';
import { EventEmitter } from 'events';
import _ from 'lodash';
import ApplicationConstants from '../constants/ApplicationConstants.js';
import IDVerificationConstants from '../constants/IDVerificationConstants.js';
import YourDetailsConstants from '../constants/YourDetailsConstants';
import DownloadConstants from '../constants/DownloadConstants';
import Mapper from '../utils/Mapper.js';
import AccountTypes from '../utils/AccountTypes.js';
import Formatter from '../utils/Formatter.js';
import Validators from '../utils/Validators.js';
import ContentService from '../services/ContentService';
import DownloadFormsHelper from '../utils/DownloadFormsHelper.js';
import WorkItemHelper from '../utils/WorkItemHelper.js';
import AuditWorkItemHelper from '../utils/AuditWorkItemHelper.js';
import IdVerificationHelper from '../utils/IdVerificationHelper.js';

//local variables
const CHANGE_EVENT = 'change';
const ApplicationActionTypes = ApplicationConstants.ActionTypes;
const ActionTypes = IDVerificationConstants.ActionTypes;
const ValidationDetails = IDVerificationConstants.ValidationDetails;
const SendNetCodeResults = IDVerificationConstants.SendNetCodeResults;
const VerifyNetCodeResults = IDVerificationConstants.VerifyNetCodeResults;
const NetCodeModelIds = IDVerificationConstants.NetCodeModelIds;

let _formModel = {},
    _consolidatedFormModel= {},
    _product = {},
    _showMoreMenu = false,
    _isJoint = false,
    _netCodeData = { items: [], isValidated: false },
    _titleList = [],
    _sendingResult = SendNetCodeResults.Waiting,
    _verifyResult = VerifyNetCodeResults.NotVerified,
    _verifyAttempts = 0,
    _applicationId = '',
    _accountNumber = '',
    _hasSubmitFailed,
    _accountType='',
    _showDownloadMenu = false,
    _formsToDownload = [],
    _downloadInProgress = false, 
    _selectedForms = [],
    _readyForDownload = false,
    _downloadedForms = '',
    _formDownloaded = true,
    _downloadFormsFailed = false,
    _disableJointResend = true;

function setReviewData(formModel, consolidatedFormModel, product) {
    _formModel = _.cloneDeep(formModel);
    _consolidatedFormModel = _.cloneDeep(consolidatedFormModel);
    _product = _.cloneDeep(product);
    _isJoint = AccountTypes.checkIfJointAccount(_formModel.form.accountType);
    _accountType = _.cloneDeep(formModel.form.accountType);
    _verifyAttempts = 0;
}

function setIdentificationMode(data) {
    _formModel = IdVerificationHelper.getUpdateFormModelWithKycTypeToUpdate(_formModel, data.kycTypeToUpdate);
}

function setCommSeeBackFile(data) {
    const commSeeBackFile = WorkItemHelper.getCommSeeBackFile(data, _formModel);
    _formModel.form.workItem = WorkItemHelper.getUpdatedFormModel(_formModel, { idVerificationBackFile: commSeeBackFile });
}

function addNetCode(data) {
    const title = Mapper.getGenderTitle(data.gender, data.title, _titleList, YourDetailsConstants.Values.GENDER_MALE, YourDetailsConstants.Values.GENDER_FEMALE);
    const name = Formatter.formatFullname(title, data.givenName, data.lastName) + '\'s';
    const masked = Formatter.maskMobileNumber(data.contactDetails.mobile);
    const resend = !_isJoint ? ApplicationConstants.YesNoValues.YES : ApplicationConstants.YesNoValues.NO;
    _netCodeData.items.push({name: name, masked: masked, mobileNumber: data.contactDetails.mobile, netCode:'', errorList:[], verified:false, resend: resend, disabled:false});
}

function setNetCodeData() {
    const data = _formModel.form.yourDetails;
    _netCodeData.items = [];
    if (_isJoint) {
        for (let i = 0; i < data.investorList.length; i++) {
            addNetCode(data.investorList[i]);
        }
    } else {
        addNetCode(data);
    }
}

function updateNetcodeModel(value, fieldId, index){
    if (fieldId === 'resend') {
        if (_netCodeData.items[index].resend === ApplicationConstants.YesNoValues.YES) {
            _netCodeData.items[index].resend = ApplicationConstants.YesNoValues.NO;
            _netCodeData.items[index].disabled = false;
        } else {
            _netCodeData.items[index].resend = ApplicationConstants.YesNoValues.YES;
            _netCodeData.items[index].disabled = true;
        }
        _netCodeData.items[index].netCode = '';
        _netCodeData.items[index].errorList=[];
        checkIfResendReady();

    } else {
        _netCodeData.items[index][fieldId] = Mapper.toTrim(value);  
        validateSingleModel(index); 
    }
}

function checkIfResendReady() {
    let itemsToResend = [];
    for (let i = 0; i < _netCodeData.items.length; i++) {
        if (_netCodeData.items[i].resend === ApplicationConstants.YesNoValues.YES) {
            itemsToResend.push(_netCodeData.items[i]);
        }
    }
    _disableJointResend = itemsToResend.length == 0;
}

function validateSingleModel(index){
    const id = index === 0 && !_isJoint ? NetCodeModelIds.Single : (NetCodeModelIds.TxtBx + NetCodeModelIds.Joint+'-'+index);    
    Validators.clearErrorListForField(_netCodeData.items[index].errorList, id);
    let data = {};
    data[ValidationDetails.Model] = _netCodeData.items[index].netCode;
    Validators.validateField(data, ValidationDetails.Rules, ValidationDetails.CustomAttributes, _netCodeData.items[index].errorList, ValidationDetails.Model, id);
}

function validateNetCodes() {
    let validEntries = [];
    for (let i = 0; i < _netCodeData.items.length; i++) {
        validateSingleModel(i);
        if (_netCodeData.items[i].errorList.length === 0) {
            validEntries.push(i);
        }
    }
    if (validEntries.length === _netCodeData.items.length) {
        _netCodeData.isValidated = true;
    }
}

function processSingleVerifyResult(result) {
    if (result && result.verifyNetCodeResult) {
        if (result.verifyNetCodeResult.verificationResult === VerifyNetCodeResults.VerifyNetCodeSuccess) {
            _verifyResult = result.verifyNetCodeResult.verificationResult;
            _formModel.hasDigitalSignature = ApplicationConstants.YesNoValues.YES;
            _formModel.DigitalSignatureTimeStamp = result.verifyNetCodeTimeStamp;

            const workItem = AuditWorkItemHelper
                .generateDigitalConsentWorkItem({
                    netCodeSentTime: _formModel.NetCodeSentTimeStamp,
                    netCodeVerificationTime: _formModel.DigitalSignatureTimeStamp,
                    investorList: [_formModel.form.yourDetails],
                    titleList:_titleList
                });

            if (_formModel.form.workItem == null) {
                _formModel.form.workItem = {
                    digitalConsentBackFile: workItem
                };
            } else {
                _formModel.form.workItem.digitalConsentBackFile = workItem;
            }
        } else if (result.verifyNetCodeResult.verificationResult === VerifyNetCodeResults.LimitReached) {
            _sendingResult = SendNetCodeResults.VerifyLimitReached;
        } else {
            const content = ContentService.getContent();
            const id = NetCodeModelIds.Single;
            _netCodeData.items[0].errorList.push({
                id: id,
                type: ApplicationConstants.messageTypes.error,
                message: content.netcodeEntry.invalidNetCode
            });
            _verifyAttempts++;
        }
    }

    if (_verifyAttempts > 4) {
        _sendingResult = SendNetCodeResults.VerifyLimitReached;
    }
}

function processMultipleVerifyResult(results) {
    if (results && results.verifyNetCodeResults && results.verifyNetCodeResults.length > 0) {
        for (let i = 0; i < results.verifyNetCodeResults.length; i++) {
            let index = 0;
            for(let j=0;j<_netCodeData.items.length;j++){
                if(results.verifyNetCodeResults[i].mobileNumber === _netCodeData.items[j].mobileNumber){
                    index = j;
                    break;
                }
            }
            if (results.verifyNetCodeResults[i].verificationResult === VerifyNetCodeResults.LimitReached) {
                _sendingResult = SendNetCodeResults.VerifyLimitReached;
                break;
            } else if (results.verifyNetCodeResults[i].verificationResult === VerifyNetCodeResults.VerifyNetCodeSuccess) {
                _netCodeData.items[index].verified = true;
            } else {
                const content = ContentService.getContent();
                const id = NetCodeModelIds.TxtBx + NetCodeModelIds.Joint + '-' + index;
                _netCodeData.items[index].errorList.push({
                    id: id,
                    type: ApplicationConstants.messageTypes.error,
                    message: content.netcodeEntry.invalidNetCode
                });
            }
        }
    }
    let verifiedCodes = 0;
    for (let j = 0; j < _netCodeData.items.length; j++) {
        if (_netCodeData.items[j].verified) {
            verifiedCodes++;
        }
    }
    if (verifiedCodes === _netCodeData.items.length) {
        _verifyResult = VerifyNetCodeResults.VerifyNetCodeSuccess;
        _formModel.hasDigitalSignature = ApplicationConstants.YesNoValues.YES;
        _formModel.DigitalSignatureTimeStamp = results.verifyNetCodeTimeStamp;

        const workItem = AuditWorkItemHelper
            .generateDigitalConsentWorkItem({
                netCodeSentTime: _formModel.NetCodeSentTimeStamp,
                netCodeVerificationTime: _formModel.DigitalSignatureTimeStamp,
                investorList: _formModel.form.yourDetails.investorList,
                titleList:_titleList
            });

        if (_formModel.form.workItem == null) {
            _formModel.form.workItem = {
                digitalConsentBackFile: workItem
            };
        } else {
            _formModel.form.workItem.digitalConsentBackFile = workItem;
        }

    } else {
        _verifyAttempts++;
    }
    if (_verifyAttempts > 4) {
        _sendingResult = SendNetCodeResults.VerifyLimitReached;
    }
}

function processResendResult(result) {
    if (result) {
        _sendingResult = result.generateSmsCodeResult;
        for (let i = 0; i < _netCodeData.items.length; i++) {
            if (_netCodeData.items[i].resend === ApplicationConstants.YesNoValues.YES) {
                _netCodeData.items[i].disabled = false;
                _netCodeData.items[i].resend = ApplicationConstants.YesNoValues.NO;
            }
        }
        _disableJointResend = true;
        if (_sendingResult === SendNetCodeResults.SendNetCodeSuccess && _formModel && _consolidatedFormModel) {
            _formModel.NetCodeSentTimeStamp = result.generateNetCodeTimeStamp;
            _consolidatedFormModel.NetCodeSentTimeStamp = result.generateNetCodeTimeStamp;
        }
    }
}

function clearVerifiedResults(){
    _verifyResult = VerifyNetCodeResults.NotVerified;
    for (let i = 0; i < _netCodeData.items.length; i++) {
        _netCodeData.items[i].verified = false;
    }
}

function processSendNetCodeResult(result) {
    if (result) {
        _sendingResult = result.generateSmsCodeResult;
        for (let i = 0; i < _netCodeData.items.length; i++) {
            _netCodeData.items[i].netCode = '';
            _netCodeData.items[i].errorList = [];
        }
        if (_sendingResult === SendNetCodeResults.SendNetCodeSuccess && _formModel && _consolidatedFormModel) {
            _formModel.NetCodeSentTimeStamp = result.generateNetCodeTimeStamp;
            _consolidatedFormModel.NetCodeSentTimeStamp = result.generateNetCodeTimeStamp;
        }
    }
}

function setApplicationId(id, wipId) {
    _applicationId = id;
    _formModel.id = id;
    _consolidatedFormModel.id = id;
    if (wipId) {
        _formModel.wipId = wipId;    
        _consolidatedFormModel.wipId = wipId;
    }
}

function setAccountNumber(accountNumber){
    _hasSubmitFailed = false;
    _accountNumber = accountNumber;
}

//TODO:: REFACTOR THIS INTO A DOWNLOAD MENU STORE
function toggleDownloadMenu(showDownloadMenu) {
    _showDownloadMenu = showDownloadMenu;
    if (showDownloadMenu && _product && _product.value) {
        _formsToDownload = DownloadFormsHelper.getFormsList(_product.value, _accountType);
    } else {
        _formsToDownload = [];
    }
    _selectedForms = [];
    _downloadInProgress = false;
    _downloadFormsFailed = false;
}

function updateFormsToDownload(index, checked) {
    if (_formsToDownload[index]) {
        _formsToDownload[index].checked = checked;
    }
}

function getSelectedForms() {
    if (_formsToDownload && _formsToDownload.length > 0) {
        _selectedForms = DownloadFormsHelper.getSelectedForms(_formsToDownload);
        _downloadInProgress = true;
    }
}

function receiveDownloadedApplicationForm(data) {
    if (data.attachments && data.attachments.length > 0) {
        let url = DownloadConstants.Base64String;
        _downloadedForms = url.replace('{contentType}', data.attachments[0].contentType).replace('{base64}', data.attachments[0].body);
    }
    _downloadFormsFailed = false;
    _formDownloaded = false;
    _downloadInProgress = false;
    _showDownloadMenu = false;
    _formsToDownload = [];
    _selectedForms = [];
}
//TODO:: REFACTOR THIS INTO A DOWNLOAD MENU STORE
function updateFormModelWorkItem(workItem) {
    _formModel.form.workItem = WorkItemHelper.getUpdatedFormModel(_formModel, workItem);
}

function updateFormModelIdVerification(idVerificationModel) {
    _formModel.form.idVerification = _.cloneDeep(idVerificationModel);
}

function updateYourDetailsForSave() {
    if (_formModel.form) {
        _formModel.form.yourDetails = 
            IdVerificationHelper.formatVerificationDocuments(_formModel.productId, _formModel.form.accountType, _formModel.form.yourDetails, _formModel.form.idVerification);
    }
}

function agreeIdVerificationForm() {
    _formModel.form.yourDetails = 
        IdVerificationHelper.formatVerificationDocuments(_formModel.productId, _formModel.form.accountType, _formModel.form.yourDetails, _formModel.form.idVerification, true);
}

class NetCodeEntryStoreClass extends EventEmitter {
    constructor() {
        super();
    }
    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    emitChange() {
        return setTimeout(()=>this.emit(CHANGE_EVENT), 0);
    }

    getFormModel() {
        return _formModel;
    }

    getConsolidatedFormModel() {
        return _consolidatedFormModel;
    }

    getProduct() {
        return _product;
    }

    getShowHideMore() {
        return _showMoreMenu;
    }

    getIsJoint() {
        return _isJoint;
    }

    getSendNetCodeResult() {
        return _sendingResult;
    }

    getNetCodeData() {
        return _netCodeData;
    }

    getTitleList() {
        return _titleList;
    }

    getVerifyResult() {
        return _verifyResult;
    }

    getApplicationId() {
        return _applicationId;
    }

    getAccountNumber(){
        return _accountNumber;
    }

    getHasSubmitFailed(){
        return _hasSubmitFailed
    }

    getAccountType() {
        return _accountType;
    }

    getShowDownloadMenu() {
        return _showDownloadMenu;
    }
    getFormsToDownload() {
        return _formsToDownload;
    }
    getEnableDownloadButton() {
        let checked = _.where(_formsToDownload, {'checked':true});
        return checked && checked.length > 0;
    }
    getDownloadInProgress() {
        return _downloadInProgress;
    }
    getSelectedForms() {
        return _selectedForms;
    }
    getReadyForDownload() {
        return _readyForDownload === true && _downloadInProgress === true;
    }
    getDownloadedForms() {
        return _downloadedForms;
    }
    getIsFormsDownloaded() {
        return _formDownloaded;
    }
    getDownloadFormsFailed() {
        if (_downloadInProgress) {
            return false;
        }
        return _downloadFormsFailed;
    }
    getDisableJointResend() {
        return _disableJointResend;
    }
}

// Initialize the singleton to register with the
// dispatcher and export for React components
const NetCodeEntryStore = new NetCodeEntryStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
NetCodeEntryStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ApplicationActionTypes.APPLICATION_SAVE_REQUEST:
        case ApplicationActionTypes.APPLICATION_SAVE_STARTING: 
            updateYourDetailsForSave();
            break;
        case ApplicationActionTypes.CLIENT_IDENTIFICATION_MODE_LOADED:
            setIdentificationMode(action.data);
            break;
        case ApplicationActionTypes.SET_COMMSEE_BACKFILE:
            setCommSeeBackFile(action.data);
            break;
        case ApplicationActionTypes.AGREE_IDVERIFICATION_FORM:
            agreeIdVerificationForm();
            break;
        case ApplicationActionTypes.REVIEW_APPLICATION:
            setReviewData(action.formModel, action.consolidatedFormModel, action.product);
            break;
        case ApplicationActionTypes.UPDATE_VERIFICATOIN_DOCUMENT:
            updateFormModelIdVerification(action.data);
            break;
        case ApplicationActionTypes.UPDATE_WORKITEM:
            updateFormModelWorkItem(action.workItem);
            break;
        case ApplicationActionTypes.SHOW_MORE_MENU:
            _showMoreMenu = action.showMoreMenu;
            break;
        case ActionTypes.UPDATE_NETCODE_MODEL:
            updateNetcodeModel(action.value, action.fieldId, action.index);
            break;
        case ApplicationActionTypes.LOAD_TITLE_LIST:
            _titleList = action.titles;
            break;
        case ActionTypes.GO_TO_NETCODE_ENTRY_PAGE:
            setNetCodeData();
            break;
        case ActionTypes.VALIDATE_NETCODE:
            validateNetCodes();
            break;
        case ActionTypes.SUBMIT_NETCODE:
            _netCodeData.isValidated = false;
            break;
        case ActionTypes.RECEIVE_SEND_NETCODE_RESULT:
            processSendNetCodeResult(action.result);
            break;
        case ActionTypes.RECEIVE_RESEND_NETCODE_RESULT:
            processResendResult(action.result);
            break;
        case ActionTypes.RECEIVE_VERIFY_NETCODE_RESULT:
            processSingleVerifyResult(action.result);
            break;
        case ActionTypes.RECEIVE_VERIFY_MUTIPLE_NETCODE_RESULTS:
            processMultipleVerifyResult(action.result);
            break;
        case ActionTypes.GO_TO_CONGRATULATIONS:
            clearVerifiedResults();
            break;
        case ApplicationActionTypes.APPLICATION_SAVE_SUCCESS:
            setApplicationId(action.applicationId, action.wipId);
            break;
        case ApplicationActionTypes.APPLICATION_SUBMIT_SUCCESS:
            setAccountNumber(action.data.accountNumber);
            break;
        case ApplicationActionTypes.APPLICATION_SUBMIT_FAILED:
            _hasSubmitFailed = true;
            _formModel.submitDate = '';
            break;
        case ApplicationActionTypes.SHOW_DOWNLOAD_MENU:
            toggleDownloadMenu(action.showDownloadMenu);
            break;
        case ApplicationActionTypes.UPDATE_FORMS_TO_DOWNLOAD:
            updateFormsToDownload(action.index, action.checked);
            break;
        case ApplicationActionTypes.PREPARE_FORMS_TO_DOWNLOAD:
            getSelectedForms();
            break;
        case ApplicationActionTypes.APPLICATION_DOWNLOAD_REQUEST:
            _readyForDownload = true;
            break;
        case ApplicationActionTypes.START_DOWNLOADING_FORMS:
            _readyForDownload = false;
            break;
        case ApplicationActionTypes.DOWNLOAD_FORMS_SUCCESS:
            receiveDownloadedApplicationForm(action.data);
            break;
        case ApplicationActionTypes.CLEAR_DOWNLOADED_FORMS:
            _downloadedForms = undefined;
            _formDownloaded = true;
            _selectedForms = [];
            break;
        case ApplicationActionTypes.DOWNLOAD_FORMS_FAILED:
            _downloadInProgress = false;
            _formDownloaded = true;
            _downloadFormsFailed = true;
            break;
        default:
            return true;
    }

    NetCodeEntryStore.emitChange();
    return true;
});

export default NetCodeEntryStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/NetCodeEntryStore.js